<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-stethoscope"></i></div>
      <div>
        Donnée de contrôle
        <div class="page-title-subheading">Gestion du suivi sanitaire</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <!-- Les selecteurs etaient des .form-group sans largeur dans un conteneur
         flex : ils se reduisaient a la largeur de leur libelle. Ils sont
         desormais poses sur une grille. -->
    <div class="card mb-3">
      <div class="card-body py-3">
        <div class="row g-3">
          <div class="col-12 col-md-4">
            <label class="form-label">Classe</label>
            <ng-select (change)="loadData2($event)" [searchable]="true" [clearable]="false"
                       placeholder="Choisir la classe">
              <ng-option *ngFor="let classroom of classrooms" [value]="classroom.id">{{classroom?.name}}</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-md-4">
            <label class="form-label">Année académique</label>
            <ng-select (change)="loadData1($event)" [searchable]="true" [clearable]="false"
                       placeholder="Choisir l'année">
              <ng-option *ngFor="let ay of ays" [value]="ay.id">{{ay?.name}}</ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-md-4">
            <label class="form-label">Apprenant</label>
            <ng-select (change)="loadData($event)" [searchable]="true" [clearable]="false"
                       placeholder="Choisir l'apprenant">
              <ng-option *ngFor="let sac of sacs" [value]="sac.id">{{sac?.student?.lastname}} {{sac?.student?.firstname}}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouveau contrôle
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                    <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                        <span>Consulter</span></button>
                </div>
                <div class="card-body">
                      <div class="d-flex justify-content-between mb-5">
                       
    
                        <div class="form-group ms-auto">
                            <label for=""> <strong>Rechercher:</strong> </label>
                            <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                        </div>
                    </div>
    
                            <p>{{data!.length}} élément(s)</p>
                            <div class="table-responsive">
                            <table class="table" >
                                <thead class="">
                                    <tr>
                                        <th style="width: 10px;">#</th>
                                        <th>Age</th>
                                        <th>Poids</th>
                                        <th>Taille</th>
                                        <th>Accuité visuel</th>
                                        <th>Sans correction</th>
                                        <th>Avec correction</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'rooms' | paginate: {
                                    id:'ngxP1',
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total } ">
                                        <td>
                                            <div class="form-check mb-2">
                                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                            
                                            </div>
                                        </td>
                                        <td>{{d?.age}}</td>
                                        <td>{{d?.weight}}</td>
                                        <td>{{d?.size}}</td>
                                        <td>{{d?.visual_acuity}}</td>
                                        <td>{{d?.without_correction}}</td>
                                        <td>{{d?.with_correction}}</td>
                                    </tr>
                                
                                </tbody>
                            </table>
                            </div>
                            <pagination-controls 
                            id="ngxP1"
                            (pageChange)="getPage($event)"
                          [maxSize]="9"
                          [directionLinks]="true"
                          [autoHide]="true"
                          [responsive]="true"
                          [previousLabel]="'Précédent'"
                          [nextLabel]="'Suivant'"
                          [screenReaderPaginationLabel]="'Pagination'"
                          [screenReaderPageLabel]="'page'"
                          [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                         </pagination-controls>
    
                </div><!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end col -->
    </div>
    
    
    <ng-template #addContent let-c="close" let-d="dismiss">
        <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Générer un livrable pour l'apprenant</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
                <div class=" form-group col-12 mb-3">
                    <label for="">Age <span class="text-danger ml-2">(*)</span></label>
                    <input type="number" min="1" name="age" class="form-control" ngModel>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Poids <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="weight" class="form-control" ngModel>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Taille <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="size" class="form-control" ngModel>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Accuité visuelle <span class="text-danger ml-2">(*)</span></label>
                    <textarea name="visual_acuity" class="form-control" ngModel></textarea>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Sans correction <span class="text-danger ml-2">(*)</span></label>
                    <textarea name="without_correction" class="form-control" ngModel></textarea>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Avec correction <span class="text-danger ml-2">(*)</span></label>
                    <textarea name="with_correction" class="form-control" ngModel></textarea>
                </div>
           
                <div class=" form-group col-12 mb-3">
                    <label for="">Dentition <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="teethiing" class="form-control" ngModel>
                </div>

                <div class=" form-group col-12 mb-3">
                    <label for="">Rhino-Parynx <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="nose" class="form-control" ngModel>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Urine <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="urine" class="form-control" ngModel>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">Radio pulmonaire <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="radio_pulmonary" class="form-control" ngModel>
                </div>
            </div>
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>
    
      <ng-template #editContent let-c="close" let-d="dismiss">
        <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Modifier une demande de permission</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <div class="row mb-3" >
          
                
             
            </div>
           
           
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
        </div>
    </form>
      </ng-template>

      <ng-template #showContent let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
          </div>
    
          <div class="modal-body">
            <div class="table-responsive table-card">
               <dl>
                <dt>Medécin à contacter en cas d'urgence</dt>
                <dd>{{d?.student?.health?.doctor_name}}</dd>
               </dl>
               <dl>
                <dt>Téléphone</dt>
                <dd>{{d?.student?.health?.doctor_phone}}</dd>
               </dl>
               <dl>
                <dt>Groupe sanguin</dt>
                <dd>{{d?.student?.health?.blood_groups}}</dd>
               </dl>
               <dl>
                <dt>Groupe sanguin</dt>
                <dd>{{d?.student?.health?.blood_groups}}</dd>
               </dl>
               <dl>
                <dt>Allergies courantes</dt>
                <dd>{{d?.student?.health?.common_allergies}}</dd>
               </dl>
               <dl>
                <dt>Antécédents churigicaux</dt>
                <dd>{{d?.student?.health?.churigical_histories}}</dd>
               </dl>
            </div>
          </div>
    </ng-template>

    <ng-template #contentPDF let-offcanvas>
        <div class="offcanvas-header">
        
            <h4 class="offcanvas-title">Visualiseur de fichier</h4>
            <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
            <ngx-extended-pdf-viewer [src]="pdfSrc"
            style="width: 100%; height: 100%"
            ></ngx-extended-pdf-viewer>
        </div>
    </ng-template>
    